import * as React from "react";
import Product from "./Product";
import Categories from "../Categories";


class ProductContainer extends React.Component {
    constructor(props) {
        super(props);
        this.refTab = React.createRef();
    }
    scrollToMyRef = () => window.scrollTo(0, this.refTab.current.offsetTop)

    render() {
        return (
            <Product scrollToMyRef={this.scrollToMyRef}  togglePopUp={this.props.togglePopUp} refTab={this.refTab}/>
        )
    }
}

export default ProductContainer;